import Repository from './Repository';
import {empty} from "../../shared/utils";

const resource = 'news';

export default {
  get() {
      return Repository.get(resource)
  },
  searchNews(searchForm) {
    let search = '?'
    if (!empty(searchForm.status)) {
      search += '&status[]=' + searchForm.status
    }
    if (!empty(searchForm.name)) {
      search += '&name=' + searchForm.name
    }
    if (!empty(searchForm.isAction)) {
      search += '&isAction=' + searchForm.isAction
    }

    if (!empty(searchForm.categories)) {
      search += '&categories[]=' + searchForm.categories
    }

    return Repository.get(resource + search)
  },
  getNews(newsId) {
      return Repository.get(resource + '/' + newsId)
  },
  createNews(payload) {
    return Repository.post(resource, payload)
  },
  updateNews(newsId, payload) {
    return Repository.put(resource + '/' + newsId, payload)
  },
}
